module.exports = __webpack_public_path__ + "img/banner_ibama.7b08c012.jpg";